import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles({
  label: {
    fontSize: '1.2rem',
    fontWeight: '500',
    marginBottom: '12px',
    color: '#248'
  },
  profiles: {
    height: '20vw',
    marginBottom: '30px'
  }
});
